import { render, staticRenderFns } from "./InputCustom.vue?vue&type=template&id=60521c59&scoped=true&"
import script from "./InputCustom.vue?vue&type=script&lang=js&"
export * from "./InputCustom.vue?vue&type=script&lang=js&"
import style0 from "./InputCustom.vue?vue&type=style&index=0&id=60521c59&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60521c59",
  null
  
)

export default component.exports